import { Parent } from "@/models";
import { GetChildrenModel, ParentService, RemoteTeachingService, FetchSessionDtoResModel } from "@/services";
import { ActionContext, ActionTree } from "vuex";
import { ParentState } from "./state";
import { defineVuexName, MODULES, vuexName } from "../utils";

const actions: ActionTree<ParentState, any> = {
  //setInfo
  async [defineVuexName(MODULES.PARENT.DISPATCHES.SET_INFO)]({ dispatch, commit }, payload: Parent) {
    await dispatch(vuexName(MODULES.PARENT.DISPATCHES.SET_ACCEPT_POLICY, false));
    commit(vuexName(MODULES.PARENT.COMMITS.SET_INFO, false), payload);
  },
  //loadChildren
  async [defineVuexName(MODULES.PARENT.DISPATCHES.LOAD_CHILDREN)]({ commit }: ActionContext<ParentState, any>) {
    const res = await ParentService.getChildren<GetChildrenModel>();
    commit(
      vuexName(MODULES.PARENT.COMMITS.SET_CHILDREN, false),
      res.children.filter((ch: { schoolClassId: any }) => ch.schoolClassId !== null),
    );
    return res;
  },
  //setAcceptPolicy
  async [defineVuexName(MODULES.PARENT.DISPATCHES.SET_ACCEPT_POLICY)]({ commit }) {
    const policyResponse: FetchSessionDtoResModel = await RemoteTeachingService.acceptPolicy("parent");
    commit(vuexName(MODULES.PARENT.COMMITS.SET_ACCEPT_POLICY, false), policyResponse.data);
  },
};

export default actions;
